import React, { Component } from "react";
import { connect } from "react-redux";

export default connect((state) => ({}))(
  class TermsOfUse extends Component {
    render() {
      const headingStyle = {
        fontStyle: "normal",
        letterSpacing: "0.16px",
        fontFamily: "Open Sans",
        color: '#4f81bd',
      };

      return (
        <div>
          {this.props.location.search.indexOf("bp-no-header=true") === -1 && (
            <div>
              <div className="banner bg-img">
                <div className="contain" />
              </div>
            </div>
          )}
          <div className="contain">
            <div className="privacy-policy">
              <h1 style={{ textAlign: "center" }}>BuyPower – Unified Terms of Use & Privacy Policy</h1>
              <hr />
              <p style={{ fontSize: "14px" }}>Last Modified: December 2023</p>
              <section>
                <h4>AGREEMENT TO OUR LEGAL TERMS</h4>
                <ol>
                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="introduction">Introduction</h3>
                      <p>Welcome to BuyPower, operated by DATAPEX DRIFTY TECHNOLOGIES LIMITED ("BuyPower", "we", "our", "us"). We provide utility payment and infrastructure services via our website [www.buypower.ng](http://www.buypower.ng), mobile apps, merchant tools, APIs, and third-party integrations (collectively, the “Services”).</p>

                      <br />
                      <p>By accessing or using any part of our Services, you agree to these Terms of Use and Privacy Policy (“Terms”). If you do not agree, please discontinue use immediately.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="eligibility">Eligibility</h3>
                      <p>You must be at least 18 years of age and have the legal capacity to enter into this agreement. If you are acting on behalf of a business, you affirm that you have authority to bind that entity.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="scope-of-services">Scope of Services</h3>
                      <p>BuyPower allows:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Self-serve users to pay for electricity, airtime, data, and utility subscriptions.</li>
                        <li style={{ margin: '10px 0px' }}>Merchants to resell utility services at their physical locations.</li>
                        <li style={{ margin: '10px 0px' }}>Enterprise/API partners (banks, fintechs, agents) to offer services via our APIs.</li>
                        <li style={{ margin: '10px 0px' }}>All users to fund a virtual wallet and transact seamlessly.</li>
                        <li style={{ margin: '10px 0px' }}>We may update, modify, or discontinue features of our Services without prior notice.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="user-registration">User Registration</h3>
                      <p>Users must register an account to access Services. You agree to:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Provide accurate and current information.</li>
                        <li style={{ margin: '10px 0px' }}>Keep your login credentials secure.</li>
                        <li style={{ margin: '10px 0px' }}>Accept responsibility for activity under your account.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="wallets-and-account-number-funding">Wallets & Account Number Funding</h3>
                      <p>We assign each user (including API partners and merchants) a virtual wallet linked to a dedicated account number (NUBAN or equivalent). Funds received into this wallet are credited for use in purchasing utility services.</p>
                      <p><strong>IMPORTANT:</strong></p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Funds credited to your wallet are non-refundable.</li>
                        <li style={{ margin: '10px 0px' }}>You may only use your wallet to pay for services provided by BuyPower.</li>
                        <li style={{ margin: '10px 0px' }}>Wallet balances are not interest-bearing.</li>
                        <li style={{ margin: '10px 0px' }}>Wallet balances cannot be withdrawn or transferred, unless explicitly enabled by a separate agreement.</li>
                        <li style={{ margin: '10px 0px' }}>Users must verify funding transactions. We are not liable for misdirected transfers.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="purchase-and-payment-terms">Purchase and Payment Terms</h3>
                      <p>Accepted payment methods:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Bank transfers to assigned wallet account.</li>
                        <li style={{ margin: '10px 0px' }}>Cards (Visa, Mastercard, Verve).</li>
                        <li style={{ margin: '10px 0px' }}>USSD & mobile money integrations.</li>
                        <li style={{ margin: '10px 0px' }}>Credit integrations (e.g. MIGO).</li>
                      </ul>
                      <p>You agree to:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Maintain accurate billing info.</li>
                        <li style={{ margin: '10px 0px' }}>Pay all applicable charges in Nigerian Naira (₦).</li>
                        <li style={{ margin: '10px 0px' }}>Assume responsibility for taxes or fees required by law.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="refund-and-reversal-policy">Refund & Reversal Policy</h3>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>No refunds on successful transactions or wallet funding.</li>
                        <li style={{ margin: '10px 0px' }}>Refunds/reversals are allowed only for:
                          <ul style={{ listStyleType: 'none' }}>
                            <li style={{ margin: '10px 0px' }}>Failed token generation.</li>
                            <li style={{ margin: '10px 0px' }}>Failed service delivery, confirmed on our end.</li>
                          </ul>
                        </li>
                        <li style={{ margin: '10px 0px' }}>Requests must be made within 72 hours of the transaction.</li>
                        <li style={{ margin: '10px 0px' }}>Contact: support@buypower.ng</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="use-of-the-platform">Use of the Platform</h3>
                      <p>You may only use our Services as intended. You agree not to:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Misrepresent your identity or affiliation.</li>
                        <li style={{ margin: '10px 0px' }}>Interfere with system integrity or security.</li>
                        <li style={{ margin: '10px 0px' }}>Use bots, scrapers, or automated agents.</li>
                        <li style={{ margin: '10px 0px' }}>Resell or white-label without permission.</li>
                        <li style={{ margin: '10px 0px' }}>Circumvent usage limits or abuse APIs.</li>
                      </ul>
                      <br />
                      <p>We reserve the right to suspend or terminate accounts for violations.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="intellectual-property">Intellectual Property</h3>
                      <p>All content, technology, designs, and data are the property of BuyPower or our licensors. You may not:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Copy or reproduce any content.</li>
                        <li style={{ margin: '10px 0px' }}>Reverse-engineer our software.</li>
                        <li style={{ margin: '10px 0px' }}>Use our branding without written consent.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="data-use-for-analytics-ai-and-strategic-collaboration">Data Use for Analytics, AI, and Strategic Collaboration</h3>
                      <p>We may use transactional and system-generated data, including raw service logs, for purposes such as:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Developing and improving AI and machine learning models</li>
                        <li style={{ margin: '10px 0px' }}>Forecasting utility demand, analyzing service performance, and supporting climate or infrastructure research</li>
                        <li style={{ margin: '10px 0px' }}>Generating aggregated insights for internal use or strategic collaboration</li>
                        <li style={{ margin: '10px 0px' }}>Supporting partnerships with technology providers, financial institutions, and global development organizations</li>
                      </ul>
                      <br />
                      <p>Where such data is used, we ensure that:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>All personal identifiers are removed prior to use</li>
                        <li style={{ margin: '10px 0px' }}>Data is processed in accordance with applicable data protection laws</li>
                        <li style={{ margin: '10px 0px' }}>Shared data is anonymized or aggregated</li>
                      </ul>

                      <br />
                      <p>We may also use such data commercially, provided that individual privacy is not compromised.</p>
                      <p>You grant us the right to use anonymized or pseudonymized data unless legally restricted.</p>
                      <p>Potential partners include AI labs, climate startups, academic institutions, agencies, and utility stakeholders.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="data-collection-and-processing">Data Collection & Processing</h3>
                      <p>We collect limited personal and transactional data necessary to operate our Services. This may include:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Contact details (e.g. name, phone number, email)</li>
                        <li style={{ margin: '10px 0px' }}>Transaction metadata (e.g. meter numbers, payment timestamps)</li>
                        <li style={{ margin: '10px 0px' }}>Device and usage data (e.g. IP address, browser, app usage logs)</li>
                      </ul>
                      <br />
                      <p>We use this data for:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Service delivery</li>
                        <li style={{ margin: '10px 0px' }}>Security and fraud prevention</li>
                        <li style={{ margin: '10px 0px' }}>User support and account management</li>
                        <li style={{ margin: '10px 0px' }}>Legal and regulatory compliance</li>
                      </ul>
                      <br />
                      <p>We do not sell personal data. Analytics or AI data is fully anonymised and aggregated.</p>
                    </div>

                    <ol>
                      <li style={{ margin: '10px 0px' }}>
                        <div>
                          <h3 style={headingStyle} id="mobile-messaging-consent-and-restrictions">Mobile Messaging Consent & Restrictions</h3>
                          <p>By providing your mobile number and submitting a form or interacting with our Services, you consent to receive transactional or customer support text messages from BuyPower.</p>
                          <p>No Sharing of Mobile Opt-In Data: We do not share your mobile number or messaging opt-in information with third parties for marketing or promotional purposes. Your consent to receive text messages is strictly for communication relating to your use of BuyPower Services.</p>
                          <p>Purpose of Messages: Text messages may include support follow-ups, service alerts, or critical account updates. Message frequency may vary depending on your activity.</p>
                          <p>Message and Data Rates: Standard message and data rates may apply as per your carrier’s terms.</p>
                        </div>
                      </li>
                    </ol>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="legal-basis-for-processing">Legal Basis for Processing</h3>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>User consent.</li>
                        <li style={{ margin: '10px 0px' }}>Performance of a contract (e.g. API partner agreement).</li>
                        <li style={{ margin: '10px 0px' }}>Legal compliance (e.g. CBN, NDPC).</li>
                        <li style={{ margin: '10px 0px' }}>Legitimate interest (e.g. fraud prevention, service improvement).</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="your-NDPR-rights">Your NDPR Rights</h3>
                      <p>Under the Nigeria Data Protection Regulation (NDPR), you have the right to:</p>

                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Access your data.</li>
                        <li style={{ margin: '10px 0px' }}>Request corrections.</li>
                        <li style={{ margin: '10px 0px' }}>Object to processing.</li>
                        <li style={{ margin: '10px 0px' }}>Request deletion (“right to be forgotten”).</li>
                        <li style={{ margin: '10px 0px' }}>Request data portability.</li>
                        <li style={{ margin: '10px 0px' }}>File a complaint with the NDPC.</li>
                      </ul>

                      <br />
                      <p>To exercise your rights, email: dpo@buypower.ng</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="data-retention-policy">Data Retention Policy</h3>
                      <p>We retain personal data:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>For the duration of your relationship with BuyPower.</li>
                        <li style={{ margin: '10px 0px' }}>As required by financial and regulatory laws (e.g. 5-7 years for transaction logs).</li>
                        <li style={{ margin: '10px 0px' }}>Or until legally mandated erasure is enforced.</li>
                        <li style={{ margin: '10px 0px' }}>After retention periods expire, data is securely deleted or anonymized.</li>
                      </ul>

                      <br />
                      <p>After expiry, data is securely deleted or anonymized.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="security-measures">Security Measures</h3>
                      <p>We implement:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>SSL encryption</li>
                        <li style={{ margin: '10px 0px' }}>Multi-factor authentication</li>
                        <li style={{ margin: '10px 0px' }}>Access control and audit logs</li>
                        <li style={{ margin: '10px 0px' }}>Encrypted backups</li>
                      </ul>
                      <p>Despite best efforts, No system is 100% secure. Use is at your own risk.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="third-party-services-and-api-integrations">Third-Party Services & API Integrations</h3>
                      <p>We may integrate or interoperate with:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Banks and card processors.</li>
                        <li style={{ margin: '10px 0px' }}>Lending platforms.</li>
                        <li style={{ margin: '10px 0px' }}>Telcos.</li>
                        <li style={{ margin: '10px 0px' }}>Utility companies</li>
                      </ul>
                      <p>Your use of these third parties is governed by their own policies. We are not liable for their actions, delays, or errors.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="cross-border-data-transfers">Cross-Border Data Transfers</h3>
                      <p>Your data may be transferred or stored outside Nigeria (e.g. AWS, Azure). We ensure:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Data is anonymized or encrypted where applicable.</li>
                        <li style={{ margin: '10px 0px' }}>Contracts with foreign processors uphold NDPR-level protections.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="data-protection-officer-(DPO)">Data Protection Officer (DPO)</h3>
                      <p>BuyPower has appointed a Data Protection Officer (DPO) to oversee compliance.</p>
                      <p>Contact:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Name: Data Protection Officer</li>
                        <li style={{ margin: '10px 0px' }}>Email: dpo@buypower.ng</li>
                        <li style={{ margin: '10px 0px' }}>Address: House 17, Road 131, 1st Avenue, Gwarimpa Estate, Abuja, Nigeria</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="reviews-feedback-and-submissions">Reviews, Feedback, and Submissions</h3>
                      <p>Any feedback, suggestions, or reviews you submit:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Must be accurate, non-offensive, and lawful</li>
                        <li style={{ margin: '10px 0px' }}>May be used by us without compensation</li>
                        <li style={{ margin: '10px 0px' }}>Do not establish co-ownership of rights</li>
                        <li style={{ margin: '10px 0px' }}>We may moderate, remove or reject reviews at our discretion.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="termination-and-account-suspension">Termination & Account Suspension</h3>
                      <p>We may suspend or terminate access:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>For violation of these Terms.</li>
                        <li style={{ margin: '10px 0px' }}>If required by law or a regulator.</li>
                        <li style={{ margin: '10px 0px' }}>Upon misuse of wallet or API access.</li>
                      </ul>
                      <p>You may also delete your account by contacting support@buypower.ng.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="dispute-resolution">Dispute Resolution</h3>
                      <p>All disputes shall be:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Resolved via arbitration under the Nigerian Institute of Chartered Arbitrators.</li>
                        <li style={{ margin: '10px 0px' }}>Held in Abuja, Nigeria.</li>
                        <li style={{ margin: '10px 0px' }}>Conducted in English.</li>
                      </ul>
                      <p>Exceptions apply for:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Intellectual property disputes.</li>
                        <li style={{ margin: '10px 0px' }}>Fraud or criminal matters.</li>
                        <li style={{ margin: '10px 0px' }}>Urgent injunctive relief.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="limitation-of-liability">Limitation of Liability</h3>
                      <p>BuyPower is not liable for:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Indirect or consequential damages.</li>
                        <li style={{ margin: '10px 0px' }}>Service interruptions or third-party failures.</li>
                        <li style={{ margin: '10px 0px' }}>Loss of wallet funds caused by your negligence.</li>
                        <li style={{ margin: '10px 0px' }}>Incorrect meter or customer information provided by you.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="force-majeure">Force Majeure</h3>
                      <p>We are not responsible for delays or failures due to:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Natural disasters.</li>
                        <li style={{ margin: '10px 0px' }}>Power outages.</li>
                        <li style={{ margin: '10px 0px' }}>Internet or telecom disruptions.</li>
                        <li style={{ margin: '10px 0px' }}>Acts of war, terrorism, or government restrictions.</li>
                      </ul>

                      <p>We are not liable for delays, interruptions, or failure to perform due to causes beyond our reasonable control, including but not limited to:</p>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>Acts of God or natural disasters.</li>
                        <li style={{ margin: '10px 0px' }}>Power grid failures, internet or telecom disruptions.</li>
                        <li style={{ margin: '10px 0px' }}>Cyberattacks or denial of service events.</li>
                        <li style={{ margin: '10px 0px' }}>Acts of war, civil unrest, or government restrictions.</li>
                        <li style={{ margin: '10px 0px' }}>Legislative or regulatory changes affecting our operations.</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="changes-to-terms">Changes to Terms</h3>
                      <p>We may modify these Terms at any time. You will be notified via email or app. Continued use of our Services means you accept the updated terms.</p>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="contact-information">Contact Information</h3>
                      <ul style={{ listStyleType: 'none' }}>
                        <li style={{ margin: '10px 0px' }}>DATAPEX DRIFTY TECHNOLOGIES LIMITED</li>
                        <li style={{ margin: '10px 0px' }}>House 17, Road 131, 1st Avenue, Gwarimpa Estate, 900108, Abuja, Nigeria</li>
                        <li style={{ margin: '10px 0px' }}>Email: support@buypower.ng</li>
                        <li style={{ margin: '10px 0px' }}>Phone: +234-908-7493-044</li>
                      </ul>
                    </div>
                  </li>

                  <li style={{ color: "#4f81bd" }}>
                    <div style={{ color: 'initial' }}>
                      <h3 style={headingStyle} id="governing-law">Governing Law</h3>
                      <p>These Terms shall be governed by the laws of the Federal Republic of Nigeria. Exclusive jurisdiction lies with courts in Abuja, Nigeria, unless otherwise stated.</p>
                    </div>
                  </li>

                </ol>
              </section>
            </div>
          </div>
        </div >
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/Terms-of-use.js